import {createOrgPath} from '@core/lib/organizations';

export const campaignPixelURL = (organization, campaign, pixel) =>
  createOrgPath(
    organization,
    `/campaigns/${campaign.slug}/pixels/${pixel.key}`
  );
